interface IconProps {
  size?: number
  className?: string
}

/**
 * Linear-style priority indicator (Medium).
 * Three ascending bars — the first two are filled; the tallest is dimmed.
 * Color is inherited from the parent via `currentColor`, so apply a text-color
 * class to control it.
 */
const IconPriorityMedium = (props: IconProps) => {
  return (
    <svg
      width={props.size ?? 16}
      height={props.size ?? 16}
      viewBox="0 0 16 16"
      fill="currentColor"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="1.5" y="8" width="3" height="6" rx="1" />
      <rect x="6.5" y="5" width="3" height="9" rx="1" />
      <rect x="11.5" y="2" width="3" height="12" rx="1" fillOpacity="0.25" />
    </svg>
  )
}

export default IconPriorityMedium
